module.exports = __webpack_public_path__ + "msc-58027223.webp";